const PAGE_IDS = {
    BADGES: 'badges-page',
    IN_PROGRESS: 'badges-in-progress-page',
    REWARDS: 'rewards-page',
} as const;

export default PAGE_IDS;
